

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class alertModal extends Vue {
    @Prop() private title! : string;
    @Prop() private message! : string;

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColorLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
}
